import { doesClassMeetOnSelectedDate } from "utils/contentManagerAllClasses";
import { normalizeToLocalDate } from "utils/dateTime";
import { formatDateKey } from "utils/scheduleResolver";
import { shiftDateKey } from "utils/presentCalendarCopy";

export const DEFAULT_CLASS_MEETING_SEARCH_DAYS = 14;

const addDays = (dateInput, daysToAdd = 0) => {
  const date = normalizeToLocalDate(dateInput);
  date.setDate(date.getDate() + daysToAdd);
  return date;
};

const findClassMeetingDate = ({
  classId,
  classItem,
  userSettings = {},
  activeDate,
  direction = 1,
  maxDays = DEFAULT_CLASS_MEETING_SEARCH_DAYS,
} = {}) => {
  const resolvedClassItem = classItem || (classId ? { classId } : null);
  if (!resolvedClassItem?.classId) return null;

  const anchorDate = normalizeToLocalDate(activeDate);
  if (Number.isNaN(anchorDate.getTime())) return null;

  const step = direction < 0 ? -1 : 1;
  const limit = Math.max(0, Number(maxDays) || 0);

  for (let dayOffset = 1; dayOffset <= limit; dayOffset += 1) {
    const candidateDate = addDays(anchorDate, step * dayOffset);
    if (
      doesClassMeetOnSelectedDate({
        classItem: resolvedClassItem,
        userSettings,
        activeDate: candidateDate,
      })
    ) {
      return candidateDate;
    }
  }

  return null;
};

export const getClassMeetingFallbackDateKey = (activeDate, direction = 1) => {
  const anchorDateKey = formatDateKey(activeDate);
  return shiftDateKey(anchorDateKey, direction < 0 ? -1 : 1);
};

export const findPreviousClassMeetingDate = ({
  classId,
  classItem,
  userSettings = {},
  activeDate,
  maxLookbackDays = DEFAULT_CLASS_MEETING_SEARCH_DAYS,
} = {}) =>
  findClassMeetingDate({
    classId,
    classItem,
    userSettings,
    activeDate,
    direction: -1,
    maxDays: maxLookbackDays,
  });

export const findNextClassMeetingDate = ({
  classId,
  classItem,
  userSettings = {},
  activeDate,
  maxLookaheadDays = DEFAULT_CLASS_MEETING_SEARCH_DAYS,
} = {}) =>
  findClassMeetingDate({
    classId,
    classItem,
    userSettings,
    activeDate,
    direction: 1,
    maxDays: maxLookaheadDays,
  });

export const resolvePreviousClassMeetingDateKey = (args = {}) => {
  const meetingDate = findPreviousClassMeetingDate(args);
  return meetingDate ? formatDateKey(meetingDate) : getClassMeetingFallbackDateKey(args.activeDate, -1);
};

export const resolveNextClassMeetingDateKey = (args = {}) => {
  const meetingDate = findNextClassMeetingDate(args);
  return meetingDate ? formatDateKey(meetingDate) : getClassMeetingFallbackDateKey(args.activeDate, 1);
};
